export default "__VITE_ASSET__J$FjmsDI__"